import whichPolygon from "which-polygon";
const isValid = (x) => {
    var _a;
    return (x.type === "tms" ||
        (x.type === "wms" && ((_a = x.available_projections) === null || _a === void 0 ? void 0 : _a.includes("EPSG:3857")))) &&
        !x.url.includes("{apikey}");
};
async function getELIQuerier() {
    const geojson = await fetch("https://osmlab.github.io/editor-layer-index/imagery.geojson").then((r) => r.json());
    const world = geojson.features
        .filter((x) => !x.geometry)
        .map((x) => x.properties)
        .filter(isValid);
    const nonWorld = {
        features: geojson.features.filter((x) => x.geometry),
        type: "FeatureCollection",
    };
    const query = whichPolygon(nonWorld);
    // the returned function is called on every query
    const wrappedQuery = (bbox) => {
        if (bbox === true)
            return world;
        const local = query.bbox(bbox);
        return [...local.filter(isValid), ...world];
    };
    wrappedQuery.raw = geojson;
    return wrappedQuery;
}
/**
 * A cached querier function to get local imagery from ELI
 */
export const eliQueryPromise = getELIQuerier().catch(console.error);
export const allImageryPromise = eliQueryPromise.then((eliQuery) => {
    const features = (eliQuery === null || eliQuery === void 0 ? void 0 : eliQuery.raw.features) || [];
    // convert to object for faster lookups
    return features.reduce((ac, item) => {
        // eslint-disable-next-line no-param-reassign
        ac[item.properties.id] = item.properties;
        return ac;
    }, {});
});
